import AccountLayout from '@/components/layout/AccountLayout';
import MembershipTab from '@/components/pages/account/membership';
import { getCustomer } from 'services/getCustomerByAccessToken';
import { MembershipDetail, MembershipOrder, ParsedMembership } from '@/types/membership';
import { CustomerInfo } from '@/types/user';
import { Pages } from '@/lib/seoData';
import { NextSSRPage, WithGetServerSidePropsContext, withServerSideProps } from 'hoc/withServerSideProps';

type MembershipPageProps = {
  tags: string[],
  orders: MembershipOrder[],
  memberships?: ParsedMembership[],
  customerInfo?: CustomerInfo,
  hasAcceptedTermsAndConditions: boolean
}

const MembershipPage: NextSSRPage<MembershipPageProps> = ({ memberships, orders, customerInfo, seo }) => {
  return (
    <AccountLayout seo={seo}>
      <MembershipTab membership={memberships ? memberships[0] : undefined} orders={orders} customerInfo={customerInfo!} />
    </AccountLayout>
  );
};

export const getServerSideProps = withServerSideProps<MembershipPageProps>(async function (context: WithGetServerSidePropsContext) {
  const baseUrl = process.env.APPSTLE_API_BASE_URL || '';
  const apiKey = process.env.APPSTLE_API_KEY || '';
  const { req, props: { accessToken } } = context;
  const hasAcceptedTermsAndConditions = !!req.cookies['termsAndConditions']

  const customer = await getCustomer({ accessToken });
  if (customer) {
    const tags = customer.tags;
    const orders = customer.orders?.nodes;
    const customerInfo = {
      firstName: customer.firstName,
      lastName: customer.lastName,
      email: customer.email,
      phone: customer.phone
    };
    const customerId =
      customer.id.split('/')[
      customer.id.split('/').length - 1
      ];

    const membershipsPaymentData = await fetch(
      baseUrl + `/subscription-customers/${customerId}?api_key=${apiKey}`
    ).then((resp) => resp.json()).catch((err) => console.error(err));

    const membershipsData = await fetch(
      baseUrl + `/subscription-customers-detail/valid/${customerId}?api_key=${apiKey}`
    ).then((resp) => resp.json()).catch((err) => console.error(err));

    // TODO: merge with pages/account/index.tsx logic for membership data.
    const memberships = membershipsData?.map((membership: MembershipDetail) => {
      return {
        id: membership.graphSubscriptionContractId,
        cleanId: membership.subscriptionContractId,
        billingPolicyInterval: membership.billingPolicyInterval,
        customerId: membership.customerId,
        status: membership.status,
        createdAt: membership.createdAt,
        updatedAt: membership.updatedAt,
        nextBillingDate: membership.nextBillingDate,
        orderId: membership.orderId,
        orderAmount: membership.orderAmount,
        activatedOn: membership.activatedOn,
        currencyCode: membership.currencyCode,
        startsAt: membership.startsAt,
        endsAt: membership.endsAt,
        paymentMethod: membershipsPaymentData?.subscriptionContracts.edges.map((edge: { node: { id: string }[] }) => edge.node).filter((node: { id: string }) =>
          node.id === membership.graphSubscriptionContractId)[0].customerPaymentMethod.instrument ?? {},
      }
    }) || []

    return {
      props: {
        tags,
        orders,
        memberships: memberships,
        customerInfo,
        hasAcceptedTermsAndConditions
      }
    };
  }

  return {
    props: {
      tags: [],
      orders: [],
      hasAcceptedTermsAndConditions
    }
  };
}, Pages.ACCOUNT_MEMBERSHIP)

export default MembershipPage;
